import { CircularProgress, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { MdsCheckCircleXs } from "@sinch/icons";
import { enqueueSnackbar } from "notistack";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useAttendance } from "@sinch/components/application/Attendace/useAttendance";

interface ConfirmMessageMenuItemProps {
  loading: boolean;
  handleClose: () => void;
  attendanceId: string;
  onLoading?: (loading: boolean) => void;
}

export const ConfirmMessageMenuItem: FC<ConfirmMessageMenuItemProps> = ({
  loading,
  handleClose,
  attendanceId,
  onLoading,
}) => {
  const { t } = useTranslation();
  const { confirmMessage } = useAttendance();

  const handleConfirmMessage = async () => {
    onLoading?.(true);
    try {
      await confirmMessage(attendanceId, true);
    } catch (e) {
      console.error(e);
      enqueueSnackbar(t("Error.anErrorHasOccurred"), { variant: "error" });
    }
    onLoading?.(false);
    handleClose();
  };

  return (
    <MenuItem disabled={loading} onClick={handleConfirmMessage}>
      <ListItemIcon>
        {loading ? <CircularProgress size={16} thickness={5} /> : <MdsIcon fontSize="small" icon={MdsCheckCircleXs} />}
      </ListItemIcon>
      <ListItemText>{t("Attendance.confirmMessage")}</ListItemText>
    </MenuItem>
  );
};
